import type { InferOutput } from 'valibot';
import { object as vObject, optional as vOptional, string as vString, number as vNumber } from 'valibot';

export const MarketingTrackingQuerySchema = vObject({
  utm_id: vOptional(vString()),
  utm_term: vOptional(vString()),
  utm_medium: vOptional(vString()),
  utm_source: vOptional(vString()),
  utm_content: vOptional(vString()),
  utm_campaign: vOptional(vString()),
  gclid: vOptional(vString()),
  fbclid: vOptional(vString()),
});

export type MarketingTracking = InferOutput<typeof MarketingTrackingSchema>;
export const MarketingTrackingSchema = vObject({
  utmId: vOptional(vString()),
  utmTerm: vOptional(vString()),
  utmMedium: vOptional(vString()),
  utmSource: vOptional(vString()),
  utmContent: vOptional(vString()),
  utmCampaign: vOptional(vString()),
  gclid: vOptional(vString()),
  fbclid: vOptional(vString()),
});

export type MarketingStorage = InferOutput<typeof MarketingStorageSchema>;
export const MarketingStorageSchema = vObject({
  parameters: MarketingTrackingSchema,
  expiresAt: vNumber(),
});

export const MARKETING_STORAGE_KEY = 'marketing-campaign';
